// 리사이즈 처리(단일 onResize 버전)
// - mount 크기 기준으로 renderer/labelRenderer 크기 동기화
// - camera가 Perspective면 aspect 갱신
// - ambience 노드들 재계산(존재 시)
export function bindResize({
  mount,
  camera,
  renderer,
  labelRenderer,
  updateMeshAmbienceNodes,
  maxDpr = 2,
}) {
  if (!mount || !camera || !renderer) return () => {};

  let rafId = 0;
  const last = { w: 0, h: 0, dpr: 0 };

  const onResize = () => {
    const newW = mount.clientWidth || 1;
    const newH = mount.clientHeight || 1;
    const dpr = Math.min(window.devicePixelRatio || 1, maxDpr);

    // 중복 호출 방지
    if (last.w === newW && last.h === newH && last.dpr === dpr) return;
    last.w = newW;
    last.h = newH;
    last.dpr = dpr;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      // 1) 카메라 비율(퍼스펙티브인 경우만)
      if (camera.isPerspectiveCamera) {
        camera.aspect = newW / newH;
        camera.updateProjectionMatrix();
      }
      // OrthographicCamera는 월드 스케일/줌 유지가 목적이라면 굳이 건들 필요 없음
      // (left/right/top/bottom을 유지하여 세로 스케일 고정, 가로는 캔버스가 잘려 보일 수 있음)
      // 필요시: 여기에서 left/right를 viewH*aspect로 재계산하는 이전 로직을 넣어도 됨.

      // 2) 렌더러/라벨렌더러 크기
      renderer.setPixelRatio(dpr);
      renderer.setSize(newW, newH, false); // 내부 해상도만, CSS는 따로
      if (labelRenderer?.setSize) labelRenderer.setSize(newW, newH);

      // 3) (선택) 오디오/앰비언스 노드 위치·게인 등 화면 종속 계산 갱신
      if (typeof updateMeshAmbienceNodes === "function") {
        updateMeshAmbienceNodes();
      }
    });
  };

  // 초기 1회
  onResize();

  // 관찰자 & 이벤트
  const ro = new ResizeObserver(onResize);
  ro.observe(mount);
  window.addEventListener("resize", onResize);

  // 해제 함수
  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    ro.disconnect();
    window.removeEventListener("resize", onResize);
  };
}
